<template>
  <div v-if="$auth.user">
    <v-toolbar color="white" flat dense>
      <v-spacer></v-spacer>
      <v-btn icon @click="logout">
        <v-icon>mdi-export</v-icon>
      </v-btn>
    </v-toolbar>
    <div class="py-10">
      <p class="mb-6" style="font-size: 25pt; text-align: center">
        <b>Hola {{ $auth.user.name }}</b>
      </p>

      <p class="mb-10" style="font-size: 20pt; text-align: center">
        Este es tú espacio de configuracion, aquí puedes registrar, editar y
        administrar: <br />
        Variables, Indices, Clima a Largo Plazo y crear Publicaciones.
      </p>

      <v-row>
        <v-col cols="3">
          <v-card outlined @click="irPublicaciones">
            <v-card-title style="text-transform: uppercase; color: #f15a24"
              >Publicaciones</v-card-title
            >
            <v-card-text style="font-size: 10pt"
              >Configurar Publicaciones</v-card-text
            >
          </v-card>
        </v-col>
        <v-col cols="3">
          <v-card outlined @click="irPublicacionesMultiples">
            <v-card-title
              style="font-size: 14pt; text-transform: uppercase; color: #f15a24"
              >Publicaciones Multiples</v-card-title
            >
            <v-card-text style="font-size: 10pt"
              >Configurar Publicaciones Multiples</v-card-text
            >
          </v-card>
        </v-col>
        <v-col cols="3">
          <v-card outlined @click="irIndices">
            <v-card-title style="text-transform: uppercase; color: #f15a24"
              >Indices</v-card-title
            >
            <v-card-text style="font-size: 10pt"
              >Configurar Indices</v-card-text
            >
          </v-card>
        </v-col>
        <v-col cols="3">
          <v-card outlined @click="irVariables">
            <v-card-title style="text-transform: uppercase; color: #f15a24"
              >Variables</v-card-title
            >
            <v-card-text style="font-size: 10pt"
              >Configurar Variables Socieconómicas
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-card outlined @click="irClima">
            <v-card-title style="text-transform: uppercase; color: #f15a24"
              >Clima</v-card-title
            >
            <v-card-text style="font-size: 10pt">Configurar Clima </v-card-text>
          </v-card>
        </v-col>
        <v-col v-if="isAdmin()" cols="3">
          <v-card outlined @click="irUsuarios">
            <v-card-title style="text-transform: uppercase; color: #f15a24"
              >Usuarios</v-card-title
            >
            <v-card-text style="font-size: 10pt"
              >Configurar Usuarios</v-card-text
            >
          </v-card>
        </v-col>
        <v-col cols="3">
          <v-card outlined @click="irPatrocinadores">
            <v-card-title style="text-transform: uppercase; color: #f15a24"
              >Socios</v-card-title
            >
            <v-card-text style="font-size: 10pt">Configurar Socios</v-card-text>
          </v-card>
        </v-col>
        <v-col cols="3">
          <v-card outlined @click="irContactos">
            <v-card-title style="text-transform: uppercase; color: #f15a24"
              >Contactos</v-card-title
            >
            <v-card-text style="font-size: 10pt"
              >Configurar Contactos</v-card-text
            >
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      user: this.$auth.user,
      rol: this.$auth.user['https://espacioh.cultivandofuturo.com/rol'],
      links: [
        {
          icon: "mdi-facebook",
          url: "https://www.facebook.com/BiovIntCIAT.eng/",
        },
        {
          icon: "mdi-twitter",
          url: "https://twitter.com/BiovIntCIAT_eng",
        },
        {
          icon: "mdi-youtube",
          url: "https://www.youtube.com/user/ciatwebg",
        },
        {
          icon: "mdi-linkedin",
          url: "https://www.linkedin.com/organization-guest/company/ciat",
        },
        {
          icon: "mdi-instagram",
          url: "https://www.instagram.com/bioversityciat/",
        },
      ],
    };
  },
  methods: {
    isAdmin(){
      return this.$auth.user['https://espacioh.cultivandofuturo.com/rol'].Id=="admin"
    },
    isEditor(){
      return this.$auth.user['https://espacioh.cultivandofuturo.com/rol'].Id=="editor"
    },
    irContactos(){
      this.$router.push("/admin/contactos");
    },
    irPatrocinadores() {
      this.$router.push("/admin/patrocinadores");
    },
    irPublicaciones() {
      this.$router.push("/admin/publicaciones");
    },
    irPublicacionesMultiples() {
      this.$router.push("/admin/publicaciones-multiples");
    },
    irIndices() {
      this.$router.push("/admin/indices");
    },
    irUsuarios() {
      this.$router.push("/admin/usuarios");
    },
    irVariables() {
      this.$router.push("/admin/variables");
    },
    irClima() {
      this.$router.push("/admin/clima");
    },
    irHome() {
      this.$router.replace("/");
    },
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin,
      });
    },
  },
};
</script>
